var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}},model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},[_vm._t("default"),_c('div',{staticClass:"d-flex"},[_c('v-spacer'),_vm._t("footer")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }